module.exports = __webpack_public_path__ + "img/des-3.7a7db7fe.png";